document.addEventListener("DOMContentLoaded", () => {
    // Function to scroll the announcement bar to a specific position
    function jumpAnnounceBar(announceActive) {
        const announceBar = document.querySelector(`.announce-bar-wrapper #announce__bar${announceActive}`);
        const viewport = document.querySelector('.announce-bar-wrapper .carousel__viewport');

        if (announceBar && viewport) {
            let scrollToAnnounceBar = announceBar.offsetLeft * announceActive;
            
            // Smooth scrolling effect
            viewport.scrollTo({
                left: scrollToAnnounceBar,
                behavior: "smooth" // Replaces jQuery's animate function
            });
        }
    }

    let indexAnnounceBar = 1; // Set loop first number
    let announcementOne = 0; // First slide
    let announcementsTotal = document.querySelectorAll('.announce-bar-wrapper .carousel__slide').length; // Total slides
    const delayAnnounceBar = 7000; // Time delay for auto-slide

    // Function to loop through the announcement bar
    function loopAnnounceBar() {
        setTimeout(function () {
            jumpAnnounceBar(announcementOne);
            indexAnnounceBar++;
            announcementOne++;

            // Reset the counter when reaching the end of announcements
            if (announcementOne >= announcementsTotal) {
                announcementOne = 0;
            }

            // Continue looping within a limit
            if (indexAnnounceBar < (10 * announcementsTotal)) {
                loopAnnounceBar();
            }

        }, delayAnnounceBar);
    }

    // Start the auto-loop for announcement bar
    loopAnnounceBar();
});
